import { render, staticRenderFns } from "./CSidebarNavDropdown2.vue?vue&type=template&id=27649106&"
import script from "./CSidebarNavDropdown2.vue?vue&type=script&lang=js&"
export * from "./CSidebarNavDropdown2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports